/**
 * Drift scenes registry.
 *
 * Each scene has a stable `id` used for the file name (`/videos/drift/<id>.webm|mp4`),
 * a `label` shown as a hint below the thumbnail rail, and an accent RGB the
 * thumbnail glow uses so the rail feels like a soft coloured constellation
 * rather than a strip of screenshots.
 *
 * Adding a new scene: drop a `.mp4` (and ideally a `.webm` transcode) into
 * `/app/frontend/public/videos/drift/` with the same id, then add an entry
 * here. Order in this array = order in the thumbnail rail.
 *
 * by David Hunt
 */

export const DRIFT_SCENES = [
  {
    id: "mountain-lake",
    label: "mountain lake",
    accent: "170, 200, 220", // pale blue
  },
  {
    id: "forest",
    label: "forest",
    accent: "160, 200, 150", // sage green
  },
  {
    id: "ocean",
    label: "ocean",
    accent: "240, 190, 150", // warm gold sunset
  },
  {
    id: "aurora",
    label: "aurora",
    accent: "150, 220, 190", // aurora green-teal
  },
  {
    id: "rain-window",
    label: "rain",
    accent: "180, 195, 220", // rainy blue
  },
];

// Where the video files live. Kept as a constant so we never sprinkle string
// paths across components.
export const DRIFT_VIDEO_BASE = "/videos/drift";

export const getDriftSceneById = (id) =>
  DRIFT_SCENES.find((s) => s.id === id) || DRIFT_SCENES[0];

// Persist the user's last-picked scene so opening drift a second time keeps
// their vibe instead of resetting to the first entry.
const STORAGE_KEY = "stillwater.driftSceneId";

export const loadDriftScenePreference = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && DRIFT_SCENES.some((s) => s.id === saved)) return saved;
  } catch (_) { /* silent */ }
  return DRIFT_SCENES[0].id;
};

export const saveDriftScenePreference = (id) => {
  try {
    if (DRIFT_SCENES.some((s) => s.id === id)) {
      localStorage.setItem(STORAGE_KEY, id);
    }
  } catch (_) { /* silent */ }
};
